module.exports = __webpack_public_path__ + "8a19b0f57065d43d5799de76cee61215.svg";